import { createSlice } from "@reduxjs/toolkit";
import updateStudyResearchApi from "@custom/rtk-apis/studyResearch/updateStudyResearch";

interface UpdateStudyResearchState {
  data: any;
  status: string;
  loading: boolean;
  msg: string | null;
}

const initialState: UpdateStudyResearchState = {
  data: [],
  status: '',
  loading: false,
  msg: null,
};

const updateStudyResearchSlice = createSlice({
  name: 'updateStudyResearch',
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateStudyResearchApi.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
        state.msg = null;
      })
      .addCase(updateStudyResearchApi.fulfilled, (state, {payload}) => {
        state.data = payload?.result;
        state.loading = false;
        state.status = payload?.status;
        state.msg = payload?.msg;
      })
      .addCase(updateStudyResearchApi.rejected, (state, {payload}) => {
        state.data = [];
        state.loading = false;
        state.status = 'failure';
        state.msg = typeof payload === 'string' ? payload : 'Failed to update study research.';
      });
  }
});

export default updateStudyResearchSlice.reducer;
export const { closeModal } = updateStudyResearchSlice.actions;
